import { combineReducers } from "redux";
import { toastReducer } from './Toaster/ToasterReducer'
import { modalReducer } from './Modal/ModalReducer'
export const MainReducer = combineReducers({
    toastReducer,
    modalReducer
})